import React from 'react';
import { FieldPathByValue, UseFormReturn } from 'react-hook-form';
import { CardBody, CardHeader, CardTitle } from '@progress/kendo-react-layout';
import SubjectProfileDetailsConfigurationCheckboxList from './checkbox-list';
import Card from '@components-clean/core/card';
import { TextBoxController } from '@components-clean/core/text-box';
import { useTranslation } from '@hooks/index';
import { SubjectProfileDetailsConfigurationFormValues } from './types';

type CheckboxKey = FieldPathByValue<
    Exclude<SubjectProfileDetailsConfigurationFormValues['treatmentStatus'], null>,
    boolean | null
>;

const checkboxKeys: CheckboxKey[] = ['cohort', 'treatmentArm', 'txStart', 'txDisc', 'txDiscReason', 'txCompleted'];

type Props = {
    control: UseFormReturn<SubjectProfileDetailsConfigurationFormValues>['control'];
    disabled: boolean;
};

const TreatmentStatusCard = ({ control, disabled }: Props) => {
    const { t } = useTranslation('admin', {
        keyPrefix: 'subjectConfig.subjectProfileDetailsConfig.treatmentStatus',
    });

    return (
        <Card padding="none" data-testid="subject-profile-details-configuration-treatment-status">
            <CardHeader>
                <CardTitle>{t('title')}</CardTitle>
            </CardHeader>

            <CardBody>
                <div>
                    <TextBoxController
                        control={control}
                        name="treatmentStatus.label"
                        required
                        maxLength={50}
                        label={`${t('field.label')}*`}
                        data-testid="checkbox-treatmentStatus-label"
                        disabled={disabled}
                    />
                </div>

                <SubjectProfileDetailsConfigurationCheckboxList
                    control={control}
                    disabled={disabled}
                    checkboxKeys={checkboxKeys.map((key) => ({
                        key: `treatmentStatus.${key}`,
                        label: t(`field.${key}`),
                    }))}
                />
            </CardBody>
        </Card>
    );
};

export default TreatmentStatusCard;
